import type { SvgProps } from '@main/core-ui/src/Icon/constants/enums';
import React from 'react';

export const EditBox: React.FC<SvgProps> = ({ color, size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      // eslint-disable-next-line max-len
      d="M14 7.96163V10.4706C14 11.4067 13.6282 12.3044 12.9663 12.9663C12.3044 13.6282 11.4066 14 10.4706 14H5.52941C4.59336 14 3.69564 13.6282 3.03374 12.9663C2.37185 12.3044 2 11.4067 2 10.4706V5.52941C2 3.58017 3.58017 2 5.52941 2H8.03837"
      stroke={color}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      // eslint-disable-next-line max-len
      d="M6.64758 7.46605L11.0571 3.05654C11.5778 2.53584 12.422 2.53584 12.9427 3.05654V3.05654C13.1927 3.30659 13.3332 3.64572 13.3332 3.99935C13.3332 4.35297 13.1927 4.69211 12.9427 4.94216L8.53322 9.35169C8.27823 9.60669 7.9474 9.7721 7.59041 9.8231L6.38047 9.99594C6.27661 10.0108 6.17182 9.97585 6.09763 9.90166C6.02345 9.82747 5.98852 9.72269 6.00335 9.61882L6.1762 8.40889C6.22719 8.05189 6.39259 7.72106 6.64758 7.46605Z"
      stroke={color}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
